module.exports = __webpack_public_path__ + "img/02.2e0c13ac.png";